
import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class QueueAdd extends Vue {
	name = '';
	location = '';
	type = '';

	saveQueue() {
		if (this.type === '') {
			this.$buefy.dialog.alert({
				message: 'Please select a queue type.',
				type: 'is-danger',
			});
			return;
		}
		this.$emit('saved', this.name, this.location, this.type);
	}
}
